module.exports = __webpack_public_path__ + "src/assets/img/photo_wise1.61b5ec7f.jpg";